import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const deleteSale = createApi({
  reducerPath: "deleteSale",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    
    deleteSale: builder.mutation({
      query: (id) => ({
        url: `/Sale/delete/${id}`,
        method: "DELETE",
      }),
    }),

  }),
});

export const { useDeleteSaleMutation } = deleteSale;